module.exports = __webpack_public_path__ + "static/img/preview.c65dd73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/elebits-underwater-game-development/preview.png
// module id = 88
// module chunks = 2